export default {
  DATE: 'date',
  PLAYER: 'player',
  TOTAL: 'total',
};
